import React, { useEffect, useRef } from "react";
import { useMotionValue, useReducedMotion } from "framer-motion";
import { GreetingSticker } from "./GreetingSticker";
import { stickers } from "../../data/greetings";
import { primeVoices } from "../../utils/speech";
export function StickerField() {
  const ref = useRef<HTMLDivElement>(null);
  const reduce = useReducedMotion() ?? false;
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  useEffect(() => primeVoices(), []);
  useEffect(() => {
    if (reduce) return;
    const onMove = (e: PointerEvent) => {
      if (e.pointerType !== "mouse") return;
      mx.set(e.clientX / window.innerWidth * 2 - 1);
      my.set(e.clientY / window.innerHeight * 2 - 1);
    };
    window.addEventListener("pointermove", onMove);
    return () => window.removeEventListener("pointermove", onMove);
  }, [reduce, mx, my]);
  return <div ref={ref} className="absolute inset-0 overflow-hidden" data-id="element-852" data-mp="1bh3g1l8sf1qt">
      {stickers.map((sticker, index) => <GreetingSticker key={sticker.code} sticker={sticker} index={index} mx={mx} my={my} constraintsRef={ref} reduce={reduce} data-id="element-853" data-mp="32kzh9g0j9m7p" data-mpi={index} />)}
    </div>;
}